import { useMemo } from "react";

import { useCategoriesComparison } from "../../categories-context";
import type { MapDataItem } from "../types";
import { processMapData, processMapDataComparison } from "../utils/dataProcessors";

import { useGeographyComparisonData, useGeographyTableSingleData } from "./geographyQueries";

export const useGeographyMapData = () => {
    const { isComparisonMode, categories = [] } = useCategoriesComparison();

    const singleQuery = useGeographyTableSingleData({ enabled: !isComparisonMode });
    const comparisonQuery = useGeographyComparisonData(categories || [], {
        enabled: isComparisonMode && (categories?.length ?? 0) > 0,
    });

    const mapData = useMemo((): MapDataItem[] => {
        if (isComparisonMode) {
            if (!comparisonQuery.data) {
                return [];
            }
            return processMapDataComparison(comparisonQuery.data);
        }

        return processMapData(singleQuery.data?.Data);
    }, [isComparisonMode, singleQuery.data, comparisonQuery.data]);

    return {
        mapData,
        isLoading: isComparisonMode ? comparisonQuery.isLoading : singleQuery.isLoading,
        isError: isComparisonMode ? comparisonQuery.isError : singleQuery.isError,
    };
};
